import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

/**
 * Checks if the current window location path contains "/mywm/user/".
 * @returns {boolean} Returns true if the path contains "/mywm/user/", otherwise returns false.
 */
export const isWMPath = () =>
  /\/mywm\/user\//.test(ssrWindow?.location?.pathname)
